import commonConstant from '../../common/_commonConstant';

export const getUsers = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_USERS_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_USERS_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};

export const createUser = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_USER_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_USER_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.CLEAR_CREATE_USER_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CLEAR_CREATE_USER_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};

export const updateUser = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_USER_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_USER_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.CLEAR_UPDATE_USER_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CLEAR_UPDATE_USER_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};

export const getUserRoles = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_USER_ROLES_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_USER_ROLES_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};

export const resetUserPassword = (state, action) => {
  switch (action.type) {
    case commonConstant.RESET_USER_PASSWORD_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.RESET_USER_PASSWORD_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.CLEAR_RESET_USER_PASSWORD_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CLEAR_RESET_USER_PASSWORD_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};
